import React from 'react';
import Footer from '../components/layout/Footer';
import { useNavigate } from 'react-router-dom';
const Courses = () => {
  window.scrollTo(0, 0);
  const navigate = useNavigate();

  const handleRegisterClick = (subject) => {
    navigate('/', { state: { scrollToContact: true, subject } });
  };
  const courses = [
    {
      id: 1,
      title: "📘 TOÁN",
      level: "Lớp 12 & 10 + 11",
      duration: "10 tuần",
      price: "Lớp 12: 2,300,000 VNĐ | Lớp 10 + 11: 2,000,000 VNĐ",
      description: "Khóa học Toán giúp học sinh nâng cao tư duy logic và làm chủ kiến thức trọng tâm.",
      features: ["Bài giảng trực quan", "Lộ trình ôn tập riêng", "Thầy cô hỗ trợ 24/7"]
    },
    {
      id: 2,
      title: "📘 LÝ",
      level: "Lớp 12 & 10 + 11",
      duration: "10 tuần",
      price: "Lớp 12: 2,000,000 VNĐ | Lớp 10 + 11: 1,800,000 VNĐ",
      description: "Ôn luyện vật lý từ cơ bản đến nâng cao với hệ thống bài tập chuyên sâu.",
      features: ["Video mô phỏng thí nghiệm", "Hệ thống câu hỏi trắc nghiệm", "Tài liệu ôn thi"]
    },
    {
      id: 3,
      title: "📘 HÓA",
      level: "Lớp 12 & 10 + 11",
      duration: "10 tuần",
      price: "Lớp 12: 2,000,000 VNĐ | Lớp 10 + 11: 1,800,000 VNĐ",
      description: "Học sâu về phản ứng, công thức và các kỹ thuật giải nhanh môn Hóa.",
      features: ["Sơ đồ phản ứng", "Ôn luyện theo chuyên đề", "Giáo án trực quan"]
    },
    {
      id: 4,
      title: "📘 VĂN",
      level: "Lớp 12 & 9",
      duration: "10 tuần",
      price: "Lớp 12: 2,000,000 VNĐ | Lớp 9: 2,200,000 VNĐ",
      description: "Phát triển kỹ năng đọc hiểu, nghị luận xã hội và văn học.",
      features: ["Phân tích chi tiết tác phẩm", "Hướng dẫn viết bài", "Ôn luyện kỹ năng"]
    },
    {
      id: 5,
      title: "📘 ANH",
      level: "Lớp 12 & 10 + 11",
      duration: "10 tuần",
      price: "Lớp 12: 2,000,000 VNĐ | Lớp 10 + 11: 1,800,000 VNĐ",
      description: "Luyện giao tiếp, phát âm chuẩn và ngữ pháp trọng tâm theo chương trình học.",
      features: ["Giáo viên bản ngữ", "Bài tập thực hành", "Lớp học tương tác"]
    },
    {
      id: 6,
      title: "📘 SINH",
      level: "Lớp 12 & 10 + 11",
      duration: "10 tuần",
      price: "Lớp 12: 2,000,000 VNĐ | Lớp 10 + 11: 1,800,000 VNĐ",
      description: "Hiểu rõ cơ chế sinh học, hệ thống di truyền và ứng dụng kiến thức vào bài tập.",
      features: ["Tranh ảnh sinh động", "Bài tập nâng cao", "Hệ thống câu hỏi trắc nghiệm"]
    },
    {
      id: 7,
      title: "📘 TOÁN LỚP 9",
      level: "Lớp 9",
      duration: "10 tuần",
      price: "2,200,000 VNĐ",
      description: "Chương trình Toán Lớp 9 chuyên sâu giúp ôn tập và bứt phá điểm số.",
      features: ["Đề thi thử", "Ôn tập theo chuyên đề", "Bài giảng dễ hiểu"]
    },
    {
      id: 8,
      title: "📘 VĂN LỚP 9",
      level: "Lớp 9",
      duration: "10 tuần",
      price: "2,200,000 VNĐ",
      description: "Khóa học giúp học sinh lớp 9 nắm chắc kỹ năng phân tích và làm bài thi vào 10.",
      features: ["Luyện đề vào 10", "Phân tích từng dạng bài", "Giáo viên đồng hành"]
    }
  ];

  return (
    <div className="pt-16 min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-primary-600 to-primary-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Khóa Học Nam Kiến Văn</h1>
          <p className="text-xl max-w-3xl mx-auto">Mỗi khóa học kéo dài **10 tuần** – Được xây dựng bài bản và cá nhân hóa theo từng trình độ học sinh</p>
        </div>
      </section>

      {/* Courses Grid */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((course) => (
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-2xl transition duration-300 flex flex-col">
                <div className="h-40 bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center">
                  <span className="text-white text-xl font-semibold">{course.title}</span>
                </div>

                <div className="flex-grow p-5 flex flex-col justify-between">
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm bg-blue-100 text-blue-700 px-2 py-1 rounded">{course.level}</span>
                      <span className="text-sm text-gray-500">{course.duration}</span>
                    </div>
                    <p className="text-gray-700 text-sm mb-3">{course.description}</p>

                    <ul className="text-sm text-gray-600 space-y-1 mb-4">
                      {course.features.map((feature, index) => (
                        <li key={index} className="flex items-start">
                          <svg className="w-4 h-4 text-green-500 mt-1 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-auto">
                    <div className="text-sm text-primary-600 font-semibold mb-2">
                      {course.price.split("|").map((line, i) => (
                        <div key={i}>{line.trim()}</div>
                      ))}
                    </div>
                    <button
                      onClick={() => handleRegisterClick(course.title)}
                      className="bg-primary-600 hover:bg-primary-700 text-white text-sm px-4 py-2 rounded-lg transition"
                    >
                      Đăng ký ngay
                    </button>

                  </div>
                </div>
              </div>

            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Courses;
